import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';
import { APPIAN_INCOME_INFO } from '@/forms/constants/services';
const resource = 'suite/webapi/ChkIncomeInfo';
export default {
    appianIncomeInfo(payload) {
        return Repository.post(`${resource}`, payload, {
            params: getParams(APPIAN_INCOME_INFO),
        });
    },
};